angular.module('impactx.company').controller('CompanyGreetingCardLayoutCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    '$routeParams',
    'BackService',
    'ToastService',
    'ToolbarService',
    '$config',
    CompanyGreetingCardLayoutCtrl
]);

function CompanyGreetingCardLayoutCtrl($scope, dataGen, TranslationService, $routeParams, BackService, ToastService, ToolbarService,
                                       $config) {
    var self = this;
    $scope.logoErrorList = [];
    $scope.footerErrorList = [];
    $scope.errorListForSave = [];
    var companyId = $routeParams.id;
    dataGen.getData($scope, {id: companyId}, "/company/greetingcardlayout/view").then(function () {
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
        defineButtons();
    });

    self.savePageData = function ($event) {
        return dataGen.postAsForm($scope, {data: $scope.data}, "/company/greetingcardlayout/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get('save'),
                action: self.savePageData,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    $scope.tinymceOptions = $config.tinymceOptions;

    self.collectErrors = function () {
        $scope.errorListForSave.length = 0;
        $scope.errorListForSave = $scope.errorListForSave.concat($scope.logoErrorList);
        $scope.errorListForSave = $scope.errorListForSave.concat($scope.footerErrorList);
    };

    function hasErrors() {
        return $scope.errorListForSave.length;
    }

    function getErrors() {
        return $scope.errorListForSave;
    }

    $scope.$watch(function () {
        return $scope.footerErrorList.length;
    }, function (newValue, oldValue) {
        if (newValue != oldValue) {
            self.collectErrors();
        }
    });

    $scope.$watch(function () {
        return $scope.logoErrorList.length;
    }, function (newValue, oldValue) {
        if (newValue != oldValue) {
            self.collectErrors();
        }
    });
}